import { createApp } from 'vue';
import AlgoliaSearchPanel from './app.vue';

export default () => {
  createApp(AlgoliaSearchPanel).mount('vue-algolia-search-panel');
};
